import React from 'react';
import { Link } from 'react-router-dom';
import { getEntityOptionLink } from '@/utils/entityHelpers';

interface OptionLinkProps {
    entity: { entityId: number; entityType: string };
    optionId: number;
    description: string;
    className?: string;
    children?: React.ReactNode;
}

/**
 * A reusable component for rendering links to entity option pages
 */
const OptionLink: React.FC<OptionLinkProps> = ({ entity, optionId, description, className = '', children }) => {
    const url = getEntityOptionLink(entity, optionId);

    return (
        <Link className={className} to={url}>
            {children || description}
        </Link>
    );
};

export default OptionLink;
